window.OwlVegas = {
	init: (container) => {
		let $owl = $('.' + container);
		if ($owl.length) {
			$owl.each(function () {
				OwlVegas.carousel($(this));
			});
		}
	},
	carousel: ($self) => {
		let event = $self.data('event') || false,
			items = $self.data('items') || 1,
			loop = $self.data('loop') || false,
			autoplay = $self.data('autoplay') || false,
			autoplayTimeout = $self.data('autoplayTimeout') || 5000,
			dots = $self.data('dots') || false,
			nav = $self.data('nav') || false,
			margin = $self.data('margin') || 0,
			stagePadding = $self.data('stagePadding') || 0,
			animateOut = $self.attr('data-animateOut') || false,
			animateIn = $self.attr('data-animateIn') || false,
			smartSpeed = $self.data('smartSpeed') || 250,
			singleItem = $self.data('singleItem') || false,
			autoWidth = $self.data('autowidth') || false,
			autoHeight = $self.attr('data-autoHeight') || false,
			center = $self.data('center') || false,
			mouseDrag = $self.attr('data-mouseDrag') !== 'false',
			touchDrag = $self.attr('data-touchDrag') !== 'false',
			pullDrag = $self.attr('data-pullDrag') !== 'false',
			responsive = {
				1400: {
					items: items
				},
				1200: {
					items: items === 1 ? 1 : 3
				},
				992: {
					items: items === 1 ? 1 : 2
				},
				768: {
					items: items === 1 ? 1 : 2
				},
				480: {
					items: 1
				},
				0: {
					items: 1
				}
			};

		// responsive
		let xs = $self.data('xs') || false; // 0px
		if (xs) {
			let params = {
				0: xs
			};

			responsive = $.extend(responsive, params);
		}

		let sm = $self.data('sm') || false; // 480px
		if (sm) {
			let params = {
				480: sm
			};

			responsive = $.extend(responsive, params);
		}

		let md = $self.data('md') || false; // 768px
		if (md) {
			let params = {
				768: md
			};

			responsive = $.extend(responsive, params);
		}

		let lg = $self.data('lg') || false; // 992
		if (lg) {
			let params = {
				992: lg
			};

			responsive = $.extend(responsive, params);
		}

		let laptop = $self.data('laptop') || false; // 992
		if (laptop) {
			let params = {
				1200: laptop
			};

			responsive = $.extend(responsive, params);
		}

		let xl = $self.data('xl') || false; // 992
		if (xl) {
			let params = {
				1400: xl
			};

			responsive = $.extend(responsive, params);
		}

		// animation
		let animatedIn = {}, animatedOut = {};

		if (animateIn) {
			animatedIn = {
				animateIn: animateIn
			}
		}
		if (animateOut) {
			animatedOut = {
				animateOut: animateOut
			}
		}

		// navigation
		let navigation = {}, navText = {};
		if (nav) {
			switch (nav) {
				case 'chevron-icon':
					navText = {
						navText: ["<span class='vg-owl-chevron'><i class='fa fa-chevron-left'></i></span>", "<span class='vg-owl-chevron'><i class='fa fa-chevron-right'></i></span>"],
					};
					break;
				case 'chevron-dark':
					navText = {
						navText: ["<span class='vg-owl-chevron vg-owl-chevron-dark vg-owl-chevron-left'></span>", "<span class='vg-owl-chevron vg-owl-chevron-dark vg-owl-chevron-right'></span>"],
					};
					break;
				case 'long-arrows':
					navText = {
						navText: ["<span class='fa fa-long-arrow-left'></span>", "<span class='fa fa-long-arrow-right'></span>"],
					};
					break;
				case 'words':
					navText = {
						navText: ["<i class='fal fa-chevron-left'></i> Предыдущие", "Следующие <i class='fal fa-chevron-right'></i>"],
					};
					break;
				default:
					navText = {
						navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
					};
			}

			navigation = $.extend({
				nav: true
			}, navText);
		}

		let options = {
			items: items,
			loop: loop,
			autoplay: autoplay,
			autoplayTimeout: autoplayTimeout,
			margin: margin,
			stagePadding: stagePadding,
			dots: dots,
			smartSpeed: smartSpeed,
			autoWidth: autoWidth,
			autoHeight: autoHeight,
			center: center,
			mouseDrag: mouseDrag,
			touchDrag: touchDrag,
			pullDrag: pullDrag,
			singleItem: singleItem,
			responsive: responsive
		};

		options = $.extend(options, animatedOut, animatedIn, navigation);
		$self.owlCarousel(options);

		if (event) {
			if (event === 'change-news') {
				$self.on('changed.owl.carousel', function(event) {
					$('.article-area').removeClass('show');
					$('#article_' + (event.page.index + 1)).addClass('show');
				})
			}
		}
	}
};